/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCampaignByNameQueryVariables = Types.Exact<{
  is_global?: Types.InputMaybe<Types.Scalars['Boolean']>;
  label_id: Types.InputMaybe<Types.Scalars['String']>;
  name: Types.Scalars['String'];
  space_id: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetCampaignByNameQuery = { __typename: 'Query', getCampaignByName: { __typename: 'CampaignByName', campaigns: Array<{ __typename: 'Campaign', active: boolean | null, name: string | null, id: string | null, campaign_id: string | null, label_id: string | null, artist: { __typename: 'Artist', spotify_id: string | null, name: string | null, facebook_id: string | null } | null } | null> | null } | null };


export const GetCampaignByNameDocument = gql`
    query getCampaignByName($is_global: Boolean = false, $label_id: String, $name: String!, $space_id: String) {
  getCampaignByName(
    name: $name
    label_id: $label_id
    space_id: $space_id
    is_global: $is_global
  ) {
    campaigns {
      active
      name
      id
      campaign_id
      label_id
      artist {
        spotify_id
        name
        facebook_id
      }
    }
  }
}
    `;

/**
 * __useGetCampaignByNameQuery__
 *
 * To run a query within a React component, call `useGetCampaignByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignByNameQuery({
 *   variables: {
 *      is_global: // value for 'is_global'
 *      label_id: // value for 'label_id'
 *      name: // value for 'name'
 *      space_id: // value for 'space_id'
 *   },
 * });
 */
export function useGetCampaignByNameQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignByNameQuery, GetCampaignByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignByNameQuery, GetCampaignByNameQueryVariables>(GetCampaignByNameDocument, options);
      }
export function useGetCampaignByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignByNameQuery, GetCampaignByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignByNameQuery, GetCampaignByNameQueryVariables>(GetCampaignByNameDocument, options);
        }
export type GetCampaignByNameQueryHookResult = ReturnType<typeof useGetCampaignByNameQuery>;
export type GetCampaignByNameLazyQueryHookResult = ReturnType<typeof useGetCampaignByNameLazyQuery>;